import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/builds/poo/webshop/frontend/src/poo/app/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/poo/webshop/frontend/src/poo/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/layouts/empty.vue").then(m => m.default || m))
}